import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetFamilyEventDetailsOfMailPath =
  operations['AdminEventController_getEventResponseMail']['parameters']['path'];
type GetFamilyEventDetailsOfMailHeaders =
  operations['AdminEventController_getEventResponseMail']['parameters']['header'];

interface GetFamilyEventDetailsOfMailProps {
  path: GetFamilyEventDetailsOfMailPath;
  headers?: OmitGroupIdInHeader<GetFamilyEventDetailsOfMailHeaders>;
}

type GetFamilyEventDetailsOfMailResponse =
  components['schemas']['List$EventResponse$mZFLkyvTelC5g8XnyQrpOw'];

export async function getFamilyEventDetailsOfMail({
  path,
  headers,
}: GetFamilyEventDetailsOfMailProps): Promise<GetFamilyEventDetailsOfMailResponse | false> {
  const response = await authenticateRequest<GetFamilyEventDetailsOfMailResponse>({
    method: 'get',
    url: `/api/v1/admin/events/${path.eventId}/details/mail`,
    headers,
  });

  console.log('getFamilyEventDetailsOfMail', { response });
  return response;
}

export type { GetFamilyEventDetailsOfMailPath, GetFamilyEventDetailsOfMailResponse };
